import React from 'react';
import '@fontsource/dm-sans';
import 'normalize.css';
import { ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './header';
import Footer from './footer';
import { theme } from '../../theme';

const styles = {
  main: {
    backgroundColor: '#fcfaf8',
    minHeight: 'calc(100vh - 285px - 75px)',
    my: '64px',
  },
};

const Layout = ({ children, style = {} }) => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Container sx={[styles.main, style]}>{children}</Container>
        <Footer />
      </ThemeProvider>
    </React.StrictMode>
  );
};

export default Layout;
